import React from "react";
// import { themeColor } from "../../constant/const";
import {
  defaultWidthHeight,
  isMobile,
  radioButtonWidget,
  resizeBorderExtraWidth,
  textWidget,
} from "../../utils/general";
export const themeColor = "#47a3ad";

function PlaceholderBorder(props) {
  const getResizeBorderExtraWidth = resizeBorderExtraWidth();
  const defaultWidth = defaultWidthHeight(props.pos.type).width;
  const defaultHeight = defaultWidthHeight(props.pos.type).height;
  const width = () => {
    const getWidth =
      props.placeholderBorder.w || props.pos.Width || defaultWidth;
    return (
      getWidth * props.scale * props.containerScale + getResizeBorderExtraWidth
    );
  };
  const height = () => {
    const getHeight =
      props.placeholderBorder.h || props.pos.Height || defaultHeight;

    return (
      getHeight * props.scale * props.containerScale + getResizeBorderExtraWidth
    );
  };

  const handleMinWidth = () => {
    if (props.pos.type === "checkbox" || props.pos.type === radioButtonWidget) {
      return props.getCheckboxRenderWidth.width + getResizeBorderExtraWidth;
    } else {
      return width();
    }
  };
  const handleMinHeight = () => {
    if (props.pos.type === "checkbox" || props.pos.type === radioButtonWidget) {
      return props.getCheckboxRenderWidth.height + getResizeBorderExtraWidth;
    } else {
      return height();
    }
  };
  return (
    <div
      onMouseEnter={() => !isMobile && props?.setDraggingEnabled(false)}
      onTouchEnd={() =>
        props.pos.type === textWidget && props?.setDraggingEnabled(false)
      }
      className="absolute inline-block w-[14px] h-[14px]  border-[0.2px] overflow-hidden border-dashed"
      style={{
        borderColor: themeColor,
        minWidth: handleMinWidth() || 0,
        minHeight: handleMinHeight() || 0,
        left: "-10px",
        top: "-10px",
      }}
    ></div>
  );
}

export default PlaceholderBorder;
